/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_roadmap_title_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로드맵 제목을 입력해주세요.`)
};

const en_roadmap_title_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a roadmap title.`)
};

/** @type {(inputs: {}) => LocalizedString} */
const ja_roadmap_title_required = ko_roadmap_title_required;

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const roadmap_title_required = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.roadmap_title_required(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("roadmap_title_required", locale)
	if (locale === "ko") return ko_roadmap_title_required(inputs)
	if (locale === "en") return en_roadmap_title_required(inputs)
	return ja_roadmap_title_required(inputs)
};